// #region Dependencias
import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import useImprovedForm from 'hooks/useImprovedForm'
import { getPagesByURLRequest, updatePageRequest } from 'store/thunks/pagesThunks'
import { colors } from 'components/Library/theme'
import Sidebar from 'components/Sidebar/Sidebar'
import Landing from 'components/Landing'
import { validacionesPagina } from 'utils/validations/pageValidations'
import { setDialogoAbierto } from 'store/slices/uiSlice'
// #endregion

// #region Estilos
const StyledCont = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`

const StyledDiv = styled.div`
  background-color: ${colors.light};
  padding: 2rem;
  width: 100%;
`
// #endregion

/**
 * Vista que renderiza el componente de landing page con la información de la
 * página seleccionada en modo de edición.
 * @class
 * @module Pages
 */
const PageEditor = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { url } = useParams()
  const { paginaSeleccionada: pagina } = useSelector((state) => state.pages)
  const [formValues, setFormValues, handleInputChange, reset] = useImprovedForm()

  /**
   * Hook useEffect para obtener la información de la página seleccionada
   * según la URL accedida mediante el thunk {@link getPagesByURLRequest}
   */
  useEffect(() => {
    dispatch(getPagesByURLRequest(url, navigate))
  }, [dispatch, navigate, url])

  /**
   * Hook useEffect para establecer los datos en el formulario del editor
   * cuando se cargan los datos de la página seleccionada.
   */
  useEffect(() => {
    reset(JSON.parse(JSON.stringify(pagina)))
  }, [pagina])

  /**
   * Función que guarda la edición de los datos de la página
   * mediante el thunk {@link updatePageRequest}
   */
  const handleSave = () => {
    const error = validacionesPagina(formValues)
    if (error) {
      return dispatch(
        setDialogoAbierto({
          abierto: true,
          tipo: 'error',
          titulo: 'Error de validación',
          mensaje: error
        })
      )
    }

    dispatch(updatePageRequest(formValues))
  }

  /**
   * Renderiza el componente si ya se cargaron los datos de la página a editar.
   */
  if (formValues.url) {
    return (
      <StyledCont>
        <StyledDiv>
          <Landing modoEdicion={true} valores={formValues} handleInputChange={handleInputChange} />
        </StyledDiv>
        <Sidebar
          modoEdicion={true}
          handleSave={handleSave}
          formValues={formValues}
          setFormValues={setFormValues}
          handleInputChange={handleInputChange}
          reset={reset}
        />
      </StyledCont>
    )
  }
}

export default PageEditor
